import { useState } from "react";
import { supabase } from "../lib/supabase";

export function Login() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function send() {
    // This Supabase project is shared with another app, so its Site URL points
    // elsewhere. Without an explicit redirect the magic link lands on the wrong
    // origin. The target must also be listed under Redirect URLs in Supabase.
    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: { emailRedirectTo: window.location.origin },
    });
    if (error) setError(error.message);
    else setSent(true);
  }

  return (
    <div className="shell" style={{ maxWidth: 420, paddingTop: "6rem" }}>
      <h1>Analytics</h1>
      <p className="muted">Search and behavioral data, joined and honest about it.</p>

      <div className="panel">
        {sent ? (
          <p>Check {email} for a sign-in link.</p>
        ) : (
          <>
            <div className="field">
              <label htmlFor="email">Email</label>
              <input id="email" type="email" value={email}
                     onChange={(e) => setEmail(e.target.value)} />
            </div>
            <button onClick={send} disabled={!email.includes("@")}>Send sign-in link</button>
            {error && <p className="caveat">{error}</p>}
          </>
        )}
      </div>
    </div>
  );
}
